$shm_hitalama_map_widget_float_image $shm_hitalama_map_widget_float
	controls /
		<= Image $mol_image
			uri <= image_uri \
	contextmenu_body /
		^
		<= Download $mol_button_download
			title \Скачать
			blob <= image_blob null
			file_name <= image_file_name \
		<= Copy_image $mol_button_minor
			click? <=> image_copy? null
			sub /
				<= Copy_image_icon $mol_icon_content_copy
				\Копировать в буфер обмена
	Tools $shm_hitalama_map_widget_tools
		widget <= widget
		Map_page <= Map_page
		Up => Up
		Down => Down
		Copy_code => Copy_code
		Lock => Lock
		Fullscreen => Fullscreen
		Link_pick => Link_pick
		Delete => Delete
		sub /
			<= Fullscreen
			<= Link_pick
			<= Up
			<= Down
			<= Copy_code
			<= Lock
			<= Delete
